import { countryOfOriginChange } from 'app/services/businessFunctions/helpers/countryOfOriginChange';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const insurantCountryOfOrigin = {
  checkoutInsurantCountryOfOriginChange() {
    countryOfOriginChange(
      FieldsEnum.CheckoutInsurantCountryOfOrigin,
      FieldsEnum.CheckoutInsurantPassport,
      FieldsEnum.CheckoutInsurantPesel,
      FormsEnum.CheckoutForm
    );
  },
};

export default insurantCountryOfOrigin;
